import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import updateLocale from "dayjs/plugin/updateLocale";
import { Calendar, dayjsLocalizer, momentLocalizer, SlotInfo } from "react-big-calendar";
import moment from "moment";
// ✅ Import moment locale for UK (Monday as first day)
import "moment/locale/en-gb";
import { useNavigate } from "react-router-dom";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { View } from "react-big-calendar";
import ManageSurveyAppointment from "./ManageSurveyAppointment";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Alery from "./Alert";
import { useDispatch } from "react-redux";
import {
  getSurveyDiaryWithEventAction,
  setAddSurveyDiaryResponse,
  setUpdateSurveyDiaryResponse,
  setUpdateSurveyEventAction,
} from "../../../store/reducers/surveyDiarySlice";
import useStyles from "../lead/survey/leadSurveyStyle";
import LeadSurveyForm from "../lead/survey/LeadSurveyForm";
import { getSingleLeadAction } from "../../../store/reducers/leadSlice";
import dayjs from "../../../utils/dayjsConfig";
import { getClientForEditAction } from "../../../store/reducers/adminClientsSlice";
import { setCancelSurveyAction } from "../../../store/reducers/leadSurveySlice";
import { getSurveySetting } from "../../../store/reducers/settingSlice";
moment.locale('en-gb');
const SurveyDiary = () => {
  dayjs.extend(weekday);
  dayjs.extend(localeData);
  dayjs.extend(updateLocale);

  dayjs.updateLocale("en", {
    weekStart: 1,
  });
  // const localizer = dayjsLocalizer(dayjs);
  const localizer = momentLocalizer(moment);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeModalLeadId, setActiveModalLeadId] = useState<string | null>(
    null,
  );
  const { user } = useSelector((state: any) => state?.user);
  const { isCanceledSurvey } = useSelector((state: any) => state?.leadSurvey);
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients,
  );
  const { surveySettingResponse } = useSelector((state: any) => state?.setting);
  // ADD THESE STATES

  const RESOURCE_PER_PAGE = 2;
  const [resourceStartIndex, setResourceStartIndex] = useState(0);
  const clientTimeZone = editClientOriginalData?.timezone || "Europe/London";
  const [selectedMonthDate, setSelectedMonthDate] = useState<Date>(
    dayjs().tz(clientTimeZone).toDate(),
  );
  const [visibleRange, setVisibleRange] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: dayjs().tz(clientTimeZone).startOf("month").format("YYYY-MM-DD"),
    endDate: dayjs().tz(clientTimeZone).endOf("month").format("YYYY-MM-DD"),
  });
  const [open, setOpen] = useState<boolean>(false); // State variable to manage dialog open/close
  const [selectedSurvey, setSelectedSurvey] = useState<string>("");
  const [tabValue, setTabValue] = useState<string>("0");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null); // State to store selected date
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [selectedResource, setSelectedResource] = useState<any>(null);
  const [pendingSurveyEvent, setPendingSurveyEvent] = useState<any>(null);
  /* Lead Survey */
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const classes = useStyles({ show });
  /* End Lead Survey*/
  const {
    surveyDiaryData,
    surveyDiaryWithEventData,
    isSurveyDiarySuccess,
    isSurveyDiaryUpdateSuccess,
    isSurveyEventSuccess,
  } = useSelector((state: any) => state?.surveyDiary);

  const [leadDetails, setLeadDetails] = useState<any>(null);
  useEffect(() => {
    setLeadDetails(
      sessionStorage.getItem("leadDetails")
        ? JSON.parse(sessionStorage.getItem("leadDetails") ?? "")
        : "",
    );
  }, []);

  const fetchSurveyDiaryByRange = useCallback(
    (startDate: string, endDate: string) => {
      dispatch(
        getSurveyDiaryWithEventAction({
          startDate,
          endDate,
        }),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    fetchSurveyDiaryByRange(visibleRange.startDate, visibleRange.endDate);
  }, [fetchSurveyDiaryByRange, visibleRange.endDate, visibleRange.startDate]);

  useEffect(() => {
    dispatch(getSurveySetting());
    dispatch(getClientForEditAction());
  }, [dispatch]);

  useEffect(() => {
    if (
      isSurveyDiarySuccess ||
      isSurveyDiaryUpdateSuccess ||
      isSurveyEventSuccess ||
      isCanceledSurvey
    ) {
      fetchSurveyDiaryByRange(visibleRange.startDate, visibleRange.endDate);
      dispatch(setAddSurveyDiaryResponse(false));
      dispatch(setUpdateSurveyDiaryResponse(false));
      dispatch(setUpdateSurveyEventAction(false));
      dispatch(setCancelSurveyAction(false));
    }
  }, [
    dispatch,
    fetchSurveyDiaryByRange,
    isSurveyDiarySuccess,
    isSurveyDiaryUpdateSuccess,
    isSurveyEventSuccess,
    visibleRange.endDate,
    visibleRange.startDate,
    isCanceledSurvey,
  ]);

  const handleNavigate = (newDate: Date) => {
    const previousMonth = dayjs(selectedMonthDate).format("YYYY-MM");
    const selectedMonth = dayjs(newDate).format("YYYY-MM");

    if (selectedMonth !== previousMonth) {
      setSelectedMonthDate(newDate);
    }
  };

  const handleRangeChange = (range: any, currentView?: View) => {
    let start: any = null;
    let end: any = null;

    if (Array.isArray(range) && range.length > 0) {
      start = range[0];
      end = range[range.length - 1];
    } else if (range?.start && range?.end) {
      start = range.start;
      end = range.end;
    }

    if (!start || !end) {
      const fallbackDate = dayjs(selectedMonthDate);
      const viewType = currentView || view;

      if (viewType === "week") {
        start = fallbackDate.startOf("week").toDate();
        end = fallbackDate.endOf("week").toDate();
      } else if (viewType === "day") {
        start = fallbackDate.startOf("day").toDate();
        end = fallbackDate.endOf("day").toDate();
      } else {
        start = fallbackDate.startOf("month").toDate();
        end = fallbackDate.endOf("month").toDate();
      }
    }

    const startDate = dayjs(start).format("YYYY-MM-DD");
    const endDate = dayjs(end).format("YYYY-MM-DD");

    if (
      startDate !== visibleRange.startDate ||
      endDate !== visibleRange.endDate
    ) {
      setVisibleRange({ startDate, endDate });
    }
  };

  useEffect(() => {
    if (leadDetails && pendingSurveyEvent) {
      setSelectedSurvey(pendingSurveyEvent?.resourceId);
      setShow(true);
      setType("survey");
      setPendingSurveyEvent(null);
    }
  }, [leadDetails, pendingSurveyEvent]);

  const handleOpen = (event?: any) => {
    if (event?.status === "PENDING") {
      if (event?.leadId) {
        setPendingSurveyEvent(event); // store event
        setActiveModalLeadId(event.leadId);
        dispatch(getSingleLeadAction(event.leadId)); // call API
      } else {
        setShow(true);
        setType("survey");
        setActiveModalLeadId(null);
      }
      return;
      // setShow(true);
      // setType("survey");
    } else {
      setTabValue(event?.type === "survey" ? "1" : "0");
      // ✅ capture leadId agar event ya leadDetails se available hai
      const resolvedLeadId =
        event?.leadId || leadDetails?.lead?.generated_id || null;
      setActiveModalLeadId(resolvedLeadId);
      if (leadDetails && leadDetails?.lead?.generated_id) {
        if (!event?.id && surveyDiaryData) {
          // Initialize the survey variable to store the found survey
          let foundSurvey = null;

          surveyDiaryData.forEach((event: any) => {
            if (event?.id === leadDetails?.lead?.survey_id) {
              foundSurvey = event?.id; // Store the matched survey event
            } else if (event?.leadId === leadDetails?.lead?.generated_id) {
              foundSurvey = event?.id; // Store the matched survey event
            }
          });

          if (foundSurvey) {
            setSelectedSurvey(foundSurvey);
          }
        }
        setOpen(true);
      } else if (
        !leadDetails &&
        !leadDetails?.lead?.generated_id &&
        event?.id
      ) {
        setOpen(true);
      } else {
        setOpenAlert(true);
      }
    }
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedSurvey("");
    setSelectedDate(null); // Reset selected date when closing
    setSelectedResource(null);
    setTabValue("0");
    setActiveModalLeadId(null); // ✅ reset
  };

  const handleGoToCustomer = (leadId: string) => {
    // sessionStorage.setItem(
    //   "selectedJobLeadId",
    //   JSON.stringify(activeModalLeadId),
    // );
    sessionStorage.setItem(
      "selectedJobLeadId",
      JSON.stringify(Number(activeModalLeadId)),
    );
    navigate("/dashboard");
  };

  const handleSelectEvent = (event: any) => {
    if (event?.roleType === "Customer") return;
    setSelectedSurvey(event?.id);
    // Extract resourceId from the slotInfo
    const resourceId = event?.resourceId ?? user?.user?.tenantId;

    // Find the corresponding resourceName from resources
    const resource = resources.find((res) => res.id === resourceId);
    const resourceName = resource?.title ?? user?.user?.name;

    // Update state with selected resourceId and resourceName
    setSelectedResource({ id: resourceId, name: resourceName });
    if (
      event?.roleType === "Surveyor" ||
      ((event?.roleType === "Super Admin" || event?.roleType === "self") &&
        resource?.id === user?.user?.tenantId) ||
      (event?.roleType === "Admin" && resource?.id === user?.user?.staff_id) ||
      user?.user?.roles?.includes("TENANT") ||
      user?.user?.roles?.includes("Admin") ||
      user?.user?.roles?.includes("Owner")
    ) {
      // ✅ NEW LOGIC
      // if (event?.leadId) {
      //   dispatch(getSingleLeadAction(event.leadId));
      //   setTimeout(() => {
      //     handleOpen(event);
      //   }, 300);
      //   return;
      // }
      handleOpen(event);
    }
  };

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    // Extract resourceId from the slotInfo
    const resourceId = slotInfo?.resourceId ?? user?.user?.tenantId;

    // Find the corresponding resourceName from resources
    const resource = resources.find((res) => res.id === resourceId);
    const resourceName = resource?.title ?? user?.user?.name;

    // Update state with selected resourceId and resourceName
    setSelectedResource({ id: resourceId, name: resourceName });
    setSelectedDate(slotInfo.start); // Set the selected date
    if (
      resource?.role === "Surveyor" ||
      (resource?.role === "Super Admin" &&
        slotInfo?.resourceId === user?.user?.tenantId) ||
      (resource?.role === "Admin" &&
        slotInfo?.resourceId === user?.user?.staff_id)
    ) {
      handleOpen(); // Open the modal
    }
  };

  const allSurveyors = [
    ...(surveyDiaryWithEventData?.surveyor_tasks?.map((task: any) => ({
      ...task,
      roleType: "Surveyor",
    })) || []),

    ...(surveyDiaryWithEventData?.admin_tasks?.map((task: any) => ({
      ...task,
      roleType: "Admin",
    })) || []),

    ...(surveyDiaryWithEventData?.super_admin_tasks?.map((task: any) => ({
      ...task,
      roleType: "Super Admin",
    })) || []),

    ...(surveyDiaryWithEventData?.customer_tasks?.map((task: any) => ({
      ...task,
      roleType: "Customer",
    })) || []),
  ];

  // Extract resources (Surveyors)
  const resources =
    allSurveyors?.map((task: any) => ({
      id: task.surveyorId,
      title: task.surveyorName,
      role: task.roleType, // Add role type to resources
    })) || [];

  // seprate address field
  const extractDetails = (description: string) => {
    if (!description)
      return {
        town: null,
        postcode: null,
        address: null,
        email: null,
        country: null,
        mobile: null,
      };

    const extractField = (label: string) => {
      const regex = new RegExp(`${label}\\s*:\\s*(.*)`, "i");
      const match = description.match(regex);

      if (!match || match[1].trim() === "" || match[1].includes(":"))
        return null;

      return match[1].trim();
    };

    // Extract multiple address lines
    const addressParts = [
      extractField("Address"),
      extractField("Address 1"),
      extractField("Address 2"),
      extractField("Address 3"),
      extractField("Address 4"),
    ].filter(Boolean);

    return {
      email: extractField("Client Email"),
      address: addressParts.join(", ") || null,
      town: extractField("Town"),
      country: extractField("Country"),
      postcode: extractField("Postcode"),
      mobile: extractField("Mobile"),
    };
  };

  const convertToClientTime = (date: any) => {
    if (!date) return null;

    const dateString = String(date);
    const hasTimezoneInfo = /([zZ]|[+-]\d{2}:?\d{2})$/.test(dateString);

    // react-big-calendar renders Date in browser local timezone.
    // Convert API time to client timezone first, then rebuild a local Date with the
    // same wall-clock parts so calendar shows client-time consistently.
    const clientDate = hasTimezoneInfo
      ? dayjs.utc(dateString).tz(clientTimeZone)
      : dayjs.tz(dateString, clientTimeZone);

    return new Date(
      clientDate.year(),
      clientDate.month(),
      clientDate.date(),
      clientDate.hour(),
      clientDate.minute(),
      clientDate.second(),
      clientDate.millisecond(),
    );
  };

  // Extract events from surveyor_tasks & admin_tasks
  const transformedEvents = allSurveyors.flatMap((task: any) => {
    // Ensure surveys exist before mapping
    const surveyEvents = (task?.surveys?.length > 0 ? task?.surveys : []).map(
      (survey: any) => {
        const { email, town, postcode, address, country, mobile } =
          extractDetails(survey.description); // Extract details from description

        return {
          id: survey?.id ?? survey?.surveyId,
          title:
            task.roleType === "Customer"
              ? `Customer survey || ${survey.customerName} || ${town ?? ""}`
              : `${survey.survey_type} || ${survey.customerName} ${town ? `|| ${town}` : ""} ${survey?.status === "PENDING" ? "|| ⚠ The survey is not scheduled to start yet" : ""}`,
          // start: dayjs.tz(survey?.start_time,clientTimeZone).toDate(),
          // end: dayjs.tz(survey?.end_time, clientTimeZone).toDate(),
          //
          start: convertToClientTime(survey?.start_time),
          end: convertToClientTime(survey?.end_time),
          //
          // start: dayjs(survey?.start_time).utc().tz(clientTimeZone).toDate(),
          // end: dayjs(survey?.end_time).utc().tz(clientTimeZone).toDate(),
          // start: new Date(
          //   survey?.start_time?.includes("Z")
          //     ? survey?.start_time
          //     : survey?.start_time,
          // ),
          // end: new Date(
          //   survey?.end_time?.includes("Z")
          //     ? survey?.end_time
          //     : survey?.end_time,
          // ),
          resourceId: task.surveyorId,
          allDay: false,
          description: survey.description || "No description",
          town, // Extracted town
          postcode, // Extracted postcode
          address, // Extracted address
          status: survey.status,
          leadStatus: survey.leadStatus,
          surveyType: survey.survey_type,
          type: "survey",
          roleType: survey?.role || task.roleType || "self", // Use task-level roleType as fallback
          // for the lead API calling set leadID
          leadId: survey?.leadId,
        };
      },
    );

    console.log("Survey Events:", surveyEvents);
    // Ensure personal events exist before mapping
    const personalEvents = (task?.personal_events || []).map((event: any) => ({
      id: event?.eventId,
      title: `${event.event_type} || ${task.surveyorName} ${event.town ? `|| ${event.town}` : ""} ${event.postcode ? `|| ${event.postcode}` : ""}`,
      // start: dayjs.utc(event.start_date).tz(clientTimeZone).toDate(),
      // end: dayjs.utc(event.end_date).tz(clientTimeZone).toDate(),
      start: convertToClientTime(event?.start_date),
      end: convertToClientTime(event?.end_date),
      resourceId: event.surveyorId || event.surveyor_id, // Ensure it links correctly
      allDay: false,
      description: event.event || "Personal Event", // Handle null values
      status: "personal",
      surveyType: "Personal",
      type: "personal",
      roleType: event?.role || task.roleType || "self", // Use task-level roleType as fallback
    }));

    return [...surveyEvents, ...personalEvents]; // Merge survey & personal events
  });

  console.log("Transformed Events:", transformedEvents);
  console.log("clientTimeZone:", clientTimeZone);

  const currentDate = new Date();

  const parseClockTime = (time: string) => {
    const match = String(time).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);

    if (!match) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      hours: Number(match[1]) || 0,
      minutes: Number(match[2]) || 0,
      seconds: Number(match[3]) || 0,
    };
  };

  const getCalendarTime = (time: string) => {
    const { hours, minutes, seconds } = parseClockTime(time);

    // For react-big-calendar min/max, keep wall-clock time stable in the browser
    // timezone so 07:00 is rendered as 07:00 in the time gutter.
    return new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      hours,
      minutes,
      seconds,
      0,
    );
  };

  const calendarMinTime = surveySettingResponse?.start_time
    ? getCalendarTime(surveySettingResponse.start_time)
    : getCalendarTime("07:00:00");

  const calendarMaxTime = surveySettingResponse?.end_time
    ? getCalendarTime(surveySettingResponse.end_time)
    : getCalendarTime("17:00:00");

  console.log("calendarMinTime:", calendarMinTime);
  // Custom event component to show time in the month view
  const EventComponent = ({ event }: any) => (
    <span style={{ fontSize: "14px" }}>
      <span>
        {dayjs(event.start).format("h:mm A")} -{" "}
        {dayjs(event.end).format("h:mm A")}
      </span>
      <br /> {event.title}
    </span>
  );

  const [view, setView] = useState<View>("day");

  const CustomMonthEvent = ({ event }: any) => (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {dayjs(event.start).format("h:mm A")} -{" "}
      {dayjs(event.end).format("h:mm A")}
      <br />
      {event.title}
    </div>
  );

  // Custom Resource Header
  const CustomResourceHeader = ({ label, resource }: any) => {
    // Define repeating color pattern (4 different colors)
    const colors = [
      "#fff2f2",
      "#f1eeff",
      "#fff3e8",
      "#e8f5f3",
      "#ffe9f6",
      "#e3f1ff",
      "#ddfaff",
    ];

    // Assign color based on index (repeats every 4 resources)
    const index = resources.findIndex((res: any) => res.id === resource.id);
    const backgroundColor = colors[index % colors.length];

    return (
      <div
        style={{
          backgroundColor,
          color: "#000",
          padding: "12px 6px",
          fontWeight: "bold",
          borderBottom: "1px solid #ccc",
          textAlign: "center",
        }}
      >
        {label}
      </div>
    );
  };

  const rangeHeaderWithYear = ({ start, end }: { start: Date; end: Date }) => {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const sameYear = startDate.year() === endDate.year();
    const sameMonth = sameYear && startDate.month() === endDate.month();

    if (sameMonth) {
      return `${startDate.format("MMMM DD")} - ${endDate.format("DD, YYYY")}`;
    }

    if (sameYear) {
      return `${startDate.format("MMMM DD")} - ${endDate.format("MMMM DD, YYYY")}`;
    }

    return `${startDate.format("MMMM DD, YYYY")} - ${endDate.format("MMMM DD, YYYY")}`;
  };

  const formats = {
    agendaHeaderFormat: rangeHeaderWithYear,
  };

  // scrolling behavior for resources
  const visibleResources = resources.slice(
    resourceStartIndex,
    resourceStartIndex + RESOURCE_PER_PAGE,
  );

  const visibleResourceIds = visibleResources.map((r: any) => r.id);

  const filteredEvents = transformedEvents.filter((event: any) =>
    visibleResourceIds.includes(event.resourceId),
  );
  console.log("Filtered Events:", filteredEvents);

  return (
    <>
      {show && type === "survey" && (
        <section className={show ? classes.surveyPopupOverlay : ""}>
          <LeadSurveyForm
            show={show}
            setShow={setShow}
            onGoToCustomer={handleGoToCustomer}
          />
        </section>
      )}
      {(view === "week" || view === "day") && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
            gap: "10px",
          }}
        >
          <button
            disabled={resourceStartIndex === 0}
            onClick={() =>
              setResourceStartIndex((prev) =>
                Math.max(prev - RESOURCE_PER_PAGE, 0),
              )
            }
            style={{
              padding: "8px 14px",
              cursor: "pointer",
            }}
          >
            Prev
          </button>

          {/* <div style={{ fontWeight: 600 }}>
            Showing {resourceStartIndex + 1} -{" "}
            {Math.min(resourceStartIndex + RESOURCE_PER_PAGE, resources.length)}{" "}
            of {resources.length}
          </div> */}

          <button
            disabled={
              resourceStartIndex + RESOURCE_PER_PAGE >= resources.length
            }
            onClick={() =>
              setResourceStartIndex((prev) => prev + RESOURCE_PER_PAGE)
            }
            style={{
              padding: "8px 14px",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        </div>
      )}
      {(user?.user?.roles?.includes("TENANT") ||
        user?.user?.roles?.includes("Admin") ||
        user?.user?.roles?.includes("Owner")) && (
        <Alery
          open={openAlert}
          alertModalShow={openAlert}
          setAlertModelShow={setOpenAlert}
          onHide={handleClose}
        />
      )}
      {open && (
        <ManageSurveyAppointment
          selectedSurvey={selectedSurvey}
          selectedDate={selectedDate} // Pass the selected date to the modal
          open={open}
          selectedResource={selectedResource}
          onHide={handleClose}
          title="Enter Survey Details"
          tabValue={tabValue}
          isReassignAction={false}
          onGoToCustomer={handleGoToCustomer}
        />
      )}
      <Calendar
        key={`${surveySettingResponse?.start_time ?? "07:00:00"}-${surveySettingResponse?.end_time ?? "17:00:00"}`}
        popup={true}
        localizer={localizer}
        // events={isClientTimeZoneReady ? filteredEvents : []}
        events={transformedEvents ?? []}
        tooltipAccessor={(event) => {
          const details = [
            event.address ? event.address : null,
            event.town ? event.town : null,
            event.postcode ? event.postcode : null,
            event.country ? event.country : null,
          ].filter(Boolean);

          return details.length > 0
            ? `${event.title}\n${details.join(", ")}`
            : event.title;
        }}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: "100%",
          whiteSpace: "normal",
          maxHeight: "auto",
        }}
        onSelectEvent={handleSelectEvent}
        selectable={true}
        onSelectSlot={handleSelectSlot}
        step={10}
        timeslots={1}
        view={view}
        onView={(newView) => setView(newView)}
        defaultDate={currentDate}
        onNavigate={handleNavigate}
        onRangeChange={handleRangeChange}
        // ✅ UPDATED
        resources={visibleResources}
        resourceIdAccessor="id"
        resourceTitleAccessor="title"
        formats={
          view === "agenda"
            ? formats
            : {
                timeGutterFormat: (date) => {
                  const minutes = dayjs(date).minute();

                  return minutes === 0 || minutes === 30
                    ? dayjs(date).format("HH:mm")
                    : "";
                },

                dayRangeHeaderFormat: rangeHeaderWithYear,
              }
        }
        enableAutoScroll={true}
        scrollToTime={calendarMinTime}
        min={calendarMinTime}
        max={calendarMaxTime}
        eventPropGetter={(event) => {
          let bgColor = "#3174AD";
          let txtColor = "#000";

          const stage = event?.leadStatus?.toUpperCase();

          const stageSurveyStatus = event;

          if (stage) {
            if (
              stage === "SURVEY" &&
              stageSurveyStatus?.status === "COMPLETED"
            ) {
              bgColor = "#00ffff";
            } else if (stage === "SURVEY") {
              bgColor = "#00ff00";
            } else if (stage === "QUOTE") {
              bgColor = "#ff0000";
            } else if (stage === "PROVISIONAL") {
              bgColor = "#FFFF00";
            } else if (stage === "CONFIRMED") {
              bgColor = "#7C3014";
              txtColor = "#FFF";
            } else if (stage === "JOB") {
              bgColor = "#a52a2a";
              txtColor = "#FFF";
            } else if (stage === "COMPLETED") {
              bgColor = "#FFF7D2";
            } else if (stage === "ARCHIVED") {
              bgColor = "#666666";
            } else if (stage === "AWAITING") {
              bgColor = "#0066ff";
              txtColor = "#FFF";
            } else if (stage === "LOST") {
              bgColor = "#f6b26b";
            } else if (stage === "DISPUTE") {
              bgColor = "#000000";
              txtColor = "#FFF";
            }
          } else {
            if (event?.type?.toUpperCase() === "SURVEY") {
              bgColor = "#00ff00";
            } else if (event?.surveyType === "Personal") {
              bgColor = "#808080";
            } else if (event?.surveyType === "Video Call") {
              bgColor = "#008000";
            } else if (event?.surveyType === "On Site") {
              bgColor = "#FF6347";
            }
          }

          return {
            style: {
              whiteSpace: "normal",
              minHeight: "20px",
              height: "auto",
              width: "100%",
              backgroundColor: bgColor,
              color: txtColor,
            },
          };
        }}
        components={{
          event: view === "month" ? EventComponent : undefined,

          month: {
            event: CustomMonthEvent,
          },

          resourceHeader: CustomResourceHeader,
        }}
      />
    </>
  );
};

export default SurveyDiary;
